export default __webpack_public_path__ + "static/media/about-us-7.cd84ee77.jpg";